import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import { ORIENTATION_RATIOS, getImageHeight } from '@utils/space';
import * as styled from './styles';

const SIZED_GAP = 16;

function DoubleImageBlock({ credit, image1, image2, imageExtended1, imageExtended2, imageHeight, imageOrientation }) {
  if (!get(image1, 'asset.fluid') || !get(image2, 'asset.fluid')) {
    return null;
  }

  const heights = getImageHeight(imageHeight);

  if (heights) {
    const items = [
      { fluid: image1.asset.fluid, imageExtended: imageExtended1 },
      { fluid: image2.asset.fluid, imageExtended: imageExtended2 },
    ].map((item) => ({ ...item, ratio: ORIENTATION_RATIOS[imageOrientation] || item.fluid.aspectRatio || 1 }));
    const rowWidth = Math.round(heights.desktop * (items[0].ratio + items[1].ratio) + SIZED_GAP);

    return (
      <styled.SizedWrapper $rowWidth={rowWidth}>
        <styled.SizedRow $gap={SIZED_GAP}>
          {items.map(({ fluid, imageExtended, ratio }, idx) => (
            <styled.SizedItem
              key={idx}
              $ratio={ratio}
              $mobileWidth={Math.round(heights.mobile * ratio)}
            >
              <styled.SizedImage
                {...imageExtended}
                fluid={fluid}
                alt={imageExtended.altText}
                ratio={1 / ratio}
              />
            </styled.SizedItem>
          ))}
        </styled.SizedRow>
        {credit && (
          <styled.SizedCaption sizes={['small', 'regular']}>
            <em>{credit}</em>
          </styled.SizedCaption>
        )}
      </styled.SizedWrapper>
    );
  }

  return (<>
    <styled.Wrapper>
      <styled.ImageWrapper>
        <styled.Image
          fluid={image1.asset.fluid}
          alt={imageExtended1.altText}
          {...imageExtended1}
        />
      </styled.ImageWrapper>
      <styled.ImageWrapper>
        <styled.Image
          fluid={image2.asset.fluid}
          alt={imageExtended2.altText}
          {...imageExtended2}
        />
      </styled.ImageWrapper>
      {(credit) && (
        <styled.DoubleCaption sizes={['small', 'regular']}>
          {credit && <em>{credit}</em>}
        </styled.DoubleCaption>
      )}
    </styled.Wrapper>
    </>
  );
}

DoubleImageBlock.propTypes = {
  imageHeight: PropTypes.oneOf(['small', 'medium', 'large']),
  imageOrientation: PropTypes.oneOf(['portrait', 'album']),
  caption: PropTypes.string,
  image1: PropTypes.object.isRequired,
  image2: PropTypes.object.isRequired,
};

export default DoubleImageBlock;
